import { render } from "./Rooms.vue?vue&type=template&id=3a506e3a&scoped=true"
import script from "./Rooms.vue?vue&type=script&lang=js"
export * from "./Rooms.vue?vue&type=script&lang=js"

import "./Rooms.vue?vue&type=style&index=0&id=3a506e3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a506e3a"]])

export default __exports__